import { Component, ContentChild, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TagItem, TagSize } from '../model/tag.model';

@Component({
  selector: 'ui2-tag',
  templateUrl: './ui2-tag.component.html',
  styleUrls: ['./ui2-tag.component.scss']
})
export class Ui2TagComponent implements OnChanges {
  /**
   * store tag label
   */
  @Input()
  label: string;

  /**
   * store tag icon
   */
  @Input()
  icon: string;

  /**
   * store related tags color
   */
  @Input()
  colors: Array<string>;

  /**
   * store tag background color
   */
  @Input()
  tagColor: string;

  @Input()
  isClickable: boolean;

  /**
   * whether or not to show close icon
   */
  @Input()
  isRemovable: boolean;

  /**
   * whether or not to show drag handle
   */
  @Input()
  isDraggable: boolean;

  /**
   * store count of documents that have this tag
   */
  @Input()
  tagCounter: number;

  /**
   * store size of tag (default, small and extraSmall)
   */
  @Input()
  size: string = TagSize.MEDIUM;

  @Output()
  onClosed: EventEmitter<TagItem> = new EventEmitter<TagItem>();

  @Output()
  onClicked: EventEmitter<string> = new EventEmitter<string>();

  /**
   * custom content injected via template
   */
  @ContentChild('tagContent')
  tagContentTmp: ElementRef;

  /**
   * tag size enum
   */
  public readonly tagSize = TagSize;

  /**
   * whether or not to show relations dots
   */
  public isColorsVisible: boolean = false;

  /**
   * whether or not to show tag count
   */
  public isTagCounterVisible: boolean = false;

  /**
   * whether or not tag is clickable, draggable or removable
   */
  public isTagInteractive: boolean = true;

  ngOnChanges(changes: SimpleChanges): void {
    // If colors is empty, hide tag relation dots
    this.isColorsVisible = changes && changes.colors && changes.colors.currentValue.length;

    // Show tag count if current tag is in more than one documents
    this.isTagCounterVisible = changes && changes.tagCounter && changes.tagCounter.currentValue > 1;

    /**
     * If the tag size is extra small,
     * 1) we should not allow tag to be removable and draggable
     * 2) we should not show counter and relations
     */
    if (changes && changes.size && changes.size.currentValue === TagSize.EXTRA_SMALL) {
      this.isColorsVisible = false;
      this.isRemovable = false;
      this.isDraggable = false;
      this.isTagCounterVisible = false;
    }

    /**
     * If the tag is not intractable i.e clickable, removable or draggable,
     * we should not show relations
     * tag size cannot be large
     */
    if (!this.isClickable && !this.isRemovable && !this.isDraggable) {
      this.isColorsVisible = this.isTagInteractive = false;
      this.size = this.size === TagSize.MEDIUM ? TagSize.SMALL : this.size;
    }
  }

  public clickTag(): void {
    if (this.isClickable) {
      this.onClicked.emit(this.label);
    }
  }

  public closeTag(event: MouseEvent): void {
    event.stopPropagation();
    this.onClosed.emit();
  }
}
